(function ($) {

	const breakpoints = {
		xxs: 480,
		xs: 576,
		sm: 762,
		md: 992,
		lg: 1200,
		xlg: 1500
	};

	setupBlockSlider('.wp-block-columns', {
		type: 'slide',
		perPage: 4,
		perMove: 1,
		pagination: false
	});

	setupWCBlockSlider('.wp-block-woocommerce-product-collection', {
		type: 'slide',
		perPage: 4,
		perMove: 1,
		pagination: false
	});

	setupBlockSlider('.wp-block-group', {
		type: 'slide',
		autoWidth: true,
		pagination: false
	});

	function setupBlockSlider(className, defaults) {
		const columns = [...document.querySelectorAll(className + '.hpy-column-slider')];

		if (!columns.length) {
			return;
		}

		columns.forEach(function (column) {
			wrap(column);
			setupSlider(column, defaults);
		});
	}

	function setupWCBlockSlider(className, defaults) {
		const columns = [...document.querySelectorAll(className + '.hpy-column-slider')];

		if (!columns.length) {
			return;
		}

		columns.forEach(function (column) {
			wrapWCCollections(column);
			setupSlider(column, defaults);
		});
	}

	function wrap(column) {
		column.classList.add('splide');
		const cols = $(column).children();
		cols.addClass('splide__slide');
		cols.wrapAll('<div class="splide__track"></div>');
		cols.wrapAll('<div class="splide__list"></div>');
	}

	function wrapWCCollections(column) {
		column.classList.add('splide');
		const slides = $(column).find('li');
		slides.parent().addClass('splide__track').wrap('<div class="relative"></div>').parent().append($('<div class="splide__arrows"></div>'));

		slides.addClass('splide__slide').wrapAll('<div class="splide__list"></div>');
	}


	function setupSlider(column, settings) {

		const gap = getGap(column);

		settings = $.extend({ gap: gap }, settings);
		settings = getAdditionalSettings(settings, column);

		if (!column.classList.contains('wp-block-woocommerce-product-collection') && settings.perPage > 1 && settings.arrows) {
			column.querySelector('.splide__track').style.marginLeft = '-' + gap;
		}

		if ('true' === column.dataset.slideOverflow) {
			column.classList.add('splide--overflow');
		}

		let splide = new Splide(column, settings);

		splide
			.on('overflow', function (isOverflow) {

				if ('true' !== column.dataset.slideInfinite) {
					splide.options = {
						arrows: isOverflow && 'true' === column.dataset.slideArrows,
						pagination: isOverflow && 'true' === column.dataset.slidePagination,
						drag: isOverflow,
					};
				}

				const gap = getGap(column);
				if (!column.classList.contains('wp-block-woocommerce-product-collection') && splide.options.perPage > 1 && splide.options.arrows) {
					column.querySelector('.splide__track').style.marginLeft = '-' + gap;
				}

			})
			.on('resize', () => {
				const gap = getGap(column);
				splide.options = {
					gap: gap
				};
				if (!column.classList.contains('wp-block-woocommerce-product-collection') && splide.options.perPage > 1 && splide.options.arrows) {
					column.querySelector('.splide__track').style.marginLeft = '-' + gap;
				}
			})

		if ('true' === column.dataset.slideAlt) {
			splide
				.on('mounted', () => changeHeight(splide, column, 0))
				.on('move', (newIndex) => changeHeight(splide, column, newIndex))
		}

		splide.mount();
	}

	function getAdditionalSettings(settings, column) {

		let totalProducts = column.querySelectorAll('.splide__slide').length

		if (column.dataset.slideShow) {
			settings.perPage = parseInt(column.dataset.slideShow);
		}

		if ('true' === column.dataset.slideInfinite) {
			if (totalProducts > settings.perPage) {
				settings.type = 'loop';
			}
		}

		if ('true' === column.dataset.slideAuto) {
			settings.autoplay = true;
			if (column.dataset.slideInterval) {
				settings.interval = parseInt(column.dataset.slideInterval);
			}
		}

		settings.arrows = 'true' === column.dataset.slideArrows;
		settings.pagination = 'true' === column.dataset.slidePagination;

		if (column.classList.contains('hpy-column-mobile-slider')) {
			let breakpoint = column.dataset.slideBreakpoint && 'all' !== column.dataset.slideBreakpoint ? breakpoints[column.dataset.slideBreakpoint] : 0;
			if (breakpoint > 0) {
				settings = {
					...settings,
					fixedWidth: column.dataset.slideMin + 'px',
					mediaQuery: 'min',
					type: 'true' === column.dataset.slideInfinite ? 'loop' : 'slide',
					breakpoints: {
						[breakpoint]: {
							perPage: settings.perPage,
							fixedWidth: '',
							omitEnd: false,
							type: settings.type
						},
					}
				}

				if (settings.type !== 'loop') {
					settings.omitEnd = true;
				}

				delete settings.perPage;
			}
		}

		return settings;
	}

	function changeHeight(splide, column, newIndex) {
		if (splide.options.perPage && splide.options.perPage > 2) {
			let slides = [...column.querySelectorAll('.splide__slide')];
			let nonCloneSlides = [...column.querySelectorAll('.splide__slide:not(.splide__slide--clone)')];
			let normal = [];
			let small = [];

			if (splide.options.perPage % 2 === 0) {
				let normal1 = newIndex + splide.options.perPage / 2;
				let normal2 = newIndex + 1 + splide.options.perPage / 2;
				let l1 = normal1 - 1;
				let l2 = normal2 + 1;

				normal.push(offsetSlideIndex(normal1, nonCloneSlides.length));
				normal.push(offsetSlideIndex(normal2, nonCloneSlides.length));
				small.push(offsetSlideIndex(l1, nonCloneSlides.length));
				small.push(offsetSlideIndex(l2, nonCloneSlides.length));
			} else {
				let normal1 = Math.ceil(newIndex + splide.options.perPage / 2);
				normal.push(offsetSlideIndex(normal1, nonCloneSlides.length));
				small.push(offsetSlideIndex(normal1 - 1, nonCloneSlides.length));
				small.push(offsetSlideIndex(normal1 + 1, nonCloneSlides.length));
			}

			slides.forEach(slide => {
				let index = parseInt(slide.getAttribute('aria-label').split(' of ')[0]);
				if (normal.includes(index)) {
					slide.classList.remove('reduced-small', 'reduced-large');
				} else if (small.includes(index)) {
					slide.classList.add('reduced-small');
					slide.classList.remove('reduced-large');
				} else {
					slide.classList.remove('reduced-small');
					slide.classList.add('reduced-large');
				}
			});

		}
	}

	function offsetSlideIndex(index, length) {
		return index > length ? index - length : index;
	}

	function getGap(element) {
		element = element.classList.contains('wp-block-woocommerce-product-collection') ? element.querySelector('.splide__track') : element;
		const computedStyle = window.getComputedStyle(element);
		let gap = computedStyle.getPropertyValue('gap').split(' ');
		return gap.length > 1 ? gap[1] : gap[0];

	}
}(jQuery));